<template>
    <HeaderComponent />
    <router-view />
    <FooterComponent />
</template>

<script>
import HeaderComponent from '@/components/HeaderComponent.vue';
import FooterComponent from '@/components/FooterComponent.vue';

export default {
  components: {
    HeaderComponent,
    FooterComponent
  },
}
</script>

<style>
@import 'bootstrap/dist/css/bootstrap.min.css';
</style>
